import { render, staticRenderFns } from "./TaskResetDialog.vue?vue&type=template&id=71215467"
import script from "./TaskResetDialog.vue?vue&type=script&lang=ts"
export * from "./TaskResetDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports